import React from 'react';

import type { AuthorResponse } from '../../../../core/features/author-bio/types.js';

import {
  getContact,
  extractUsernameFromLink,
} from '../../components/authorBio/helpers.js';
import Image from '../../components/teasers/teaserComponents/Image.js';
import { frontendConfig } from '../../../../core/system/config/frontend.server.js';

const { cdnUrlInternal } = frontendConfig;

interface AuthorInfoProps {
  author: AuthorResponse;
  isMobile?: boolean;
}

const AuthorInfo: React.FC<AuthorInfoProps> = ({ author, isMobile }) => {
  const { title, description, contacts, image, workingTitle } = author;

  const email = getContact(contacts, 'email');
  const facebookLink = getContact(contacts, 'facebook');
  const instagramLink = getContact(contacts, 'instagram');

  return (
    <div className="author">
      {image && (
        <Image
          imageAsset={{ id: image }}
          title={title || ''}
          width={576}
          height={576}
        />
      )}
      <div className="info-wrapper">
        {workingTitle && <h2 className="working-title">{workingTitle}</h2>}
        {title && <h1>{title}</h1>}
        {description && <p className="author-description">{description}</p>}

        <div className="contacts">
          {email && (
            <a className="contact mail" href={`mailto:${email}`}>
              <img
                src={`${cdnUrlInternal}/vink/images/icons/email.svg`}
                alt="contact on email"
              />
              {!isMobile && email}
            </a>
          )}
          {instagramLink && (
            <a
              className="contact"
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${cdnUrlInternal}/vink/images/footer/instagram-logo.svg`}
                alt="link to instagram account"
              />
              {!isMobile && extractUsernameFromLink(instagramLink)}
            </a>
          )}
          {facebookLink && (
            <a
              className="contact"
              href={facebookLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${cdnUrlInternal}/vink/images/icons/facebook.svg`}
                alt="link to facebook account"
              />
              {!isMobile && extractUsernameFromLink(facebookLink)}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthorInfo;
